module.exports = __webpack_public_path__ + "img/ring_r_s_null_null.86b37852.png";